export enum STATE {
  WAIT = 0, //等待
  PROCESS = 1, //处理
  DONE = 2, //完成
  ERROR = 3, //失败
}
